import { render } from "./ParticipantsList.vue?vue&type=template&id=4f38f967"
import script from "./ParticipantsList.vue?vue&type=script&lang=js"
export * from "./ParticipantsList.vue?vue&type=script&lang=js"

import "./ParticipantsList.vue?vue&type=style&index=0&id=4f38f967&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__